/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Envelope: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="envelope" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M113.3475 982.2175C113.3475 1044.8200000000002 164.0925 1095.565 226.695 1095.565H1133.3474999999999C1195.9499999999998 1095.565 1246.695 1044.8200000000002 1246.695 982.2175V377.7825000000002C1246.695 315.1800000000001 1195.9499999999998 264.435 1133.3474999999999 264.435H113.3474999999998V982.2175zM1061.0125 1020H298.9875L653.31 665.6775C668.0575 650.93 691.985 650.93 706.7325000000001 665.6775L1061.055 1020zM201.62 1010.5225C193.8 1003.595 188.87 993.48 188.87 982.2175V340H1133.305C1154.1725 340 1171.0875 356.915 1171.0875 377.7825000000001V982.2175C1171.0875 993.48 1166.1575 1003.595 1158.3374999999999 1010.48L760.1125 612.255C715.8699999999999 568.0124999999999 644.0874999999999 568.0124999999999 599.8449999999999 612.255L201.6199999999999 1010.48z" : "M90.678 785.774C90.678 835.856 131.274 876.452 181.356 876.452H906.6779999999998C956.7599999999998 876.452 997.3559999999998 835.856 997.3559999999998 785.774V302.2260000000001C997.3559999999998 252.1440000000001 956.7599999999998 211.548 906.6779999999998 211.548H90.6779999999998V785.774zM848.81 816H239.19L522.648 532.542C534.446 520.7439999999999 553.588 520.7439999999999 565.3860000000001 532.542L848.844 816zM161.296 808.4179999999999C155.04 802.876 151.096 794.784 151.096 785.7739999999999V272H906.644C923.338 272 936.87 285.5320000000001 936.87 302.226V785.7739999999999C936.87 794.784 932.926 802.876 926.67 808.384L608.0899999999999 489.804C572.6959999999999 454.41 515.2699999999999 454.41 479.8759999999999 489.804L161.2959999999999 808.384z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Envelope.displayName = `Blueprint5.Icon.Envelope`;
export default Envelope;
